import { Icon, IconButton } from '@smartgift/frontend-toolkit';
import { range } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

function Pagination({ pageIndex, setPageIndex, limit, totalDocs }) {
  const totalPages = Math.ceil(totalDocs / limit);

  const start = 1;
  const end = totalPages + 1;

  const onPageClick = number => {
    setPageIndex(number);
  };

  return (
    <S.Pagination>
      <IconButton
        onClick={() => {
          onPageClick(pageIndex - 1);
        }}
        disabled={pageIndex === start}
        variant="text"
        size="lg"
        color="secondary"
        style={{ marginRight: 10 }}
      >
        <Icon name="left-chevron" />
      </IconButton>
      {range(start, end).map(number => (
        <S.PaginationPage
          key={`page_${number}`}
          active={number === pageIndex}
          onClick={() => onPageClick(number)}
          variant={number === pageIndex ? 'contained' : 'text'}
          color="secondary"
          size="lg"
          rounded={false}
        >
          {number}
        </S.PaginationPage>
      ))}
      <IconButton
        onClick={() => {
          onPageClick(pageIndex + 1);
        }}
        disabled={pageIndex === totalPages}
        variant="text"
        size="lg"
        color="secondary"
        style={{ marginLeft: 10 }}
      >
        <Icon name="right-chevron" />
      </IconButton>
    </S.Pagination>
  );
}

Pagination.propTypes = {
  pageIndex: PropTypes.number,
  setPageIndex: PropTypes.func,
  limit: PropTypes.number,
  totalDocs: PropTypes.number
};

export { Pagination };
